import _ from 'lodash';

import store from '@/store';
import { newClient, canAuth, routes } from './api_service';

const storeUserNavigationInfo = (result) => {
  const data = _.get(result, 'data');
  if (_.isEmpty(data) || JSON.stringify(data) === window.localStorage.userNavigation) {
    return;
  }
  window.localStorage.userNavigation = JSON.stringify(data);
  store.commit('app/setActiveUser', _.get(data, 'data'));
  store.commit('app/setAuthToken', _.get(data, 'meta["auth-token"]'));
  store.commit('app/setSitesAndPermissions', _.get(data, 'included', []));
};

const handleLoginSuccess = (result) => {
  storeUserNavigationInfo(result);
  return _.get(result, 'data.data.attributes');
};

const handleLoginFailure = (error) => {
  const errorMessage = _.get(error, 'response.data.errors[0].title');
  throw errorMessage;
};

export const updateUserNavigationInfo = () => {
  canAuth() &&
    newClient()
      .get(routes.userNavigationInfo)
      .then(storeUserNavigationInfo);
};

export const login = (email, password) => {
  const loginInfo = { email, password };
  return newClient()
    .post(routes.login, loginInfo)
    .then(handleLoginSuccess)
    .catch(handleLoginFailure);
};

export const tokenLogin = (token) => {
  const loginInfo = { 'auth-token': token };
  return newClient()
    .post(routes.login, loginInfo)
    .then(handleLoginSuccess)
    .catch(handleLoginFailure);
};

export const logout = () => {
  store.commit('app/logout');
  // TODO: figure out how to get this toast to display only after navigation to /login
  // store.commit('app/setToast', {
  //   active: true,
  //   status: 'error',
  //   text: 'You were logged out',
  // });
};

export default {
  login,
  logout,
};
